



import EventTicketListComponent from "@/components/admin/event/eventTicketListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventTicketListPage",
  components: {
    EventTicketListComponent,
  },
})
export default class EventTicketListPage extends Vue {}
